import { render, staticRenderFns } from "./orderServicerHang.vue?vue&type=template&id=23af0a35&"
import script from "./orderServicerHang.vue?vue&type=script&lang=ts&"
export * from "./orderServicerHang.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports